/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../../shared/types/__generated__/graphql"
import { PriceListFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type PriceListsQueryVariables = Exact<{ [key: string]: never }>

export type PriceListsQuery = {
  __typename: "Query"
  priceLists?: Array<{
    __typename: "PriceList"
    id: string
    title?: string | null
    isCurrent?: boolean | null
    isValid?: boolean | null
    validityKey?: string | null
  }> | null
}

export const PriceListsDocument = gql`
  query PriceLists {
    priceLists
      @rest(type: "PriceList", path: "/price/price-lists?isValid=true") {
      ...PriceList
    }
  }
  ${PriceListFragmentDoc}
`

/**
 * __usePriceListsQuery__
 *
 * To run a query within a React component, call `usePriceListsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceListsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePriceListsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PriceListsQuery,
    PriceListsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PriceListsQuery, PriceListsQueryVariables>(
    PriceListsDocument,
    options
  )
}
export function usePriceListsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PriceListsQuery,
    PriceListsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PriceListsQuery, PriceListsQueryVariables>(
    PriceListsDocument,
    options
  )
}
// @ts-ignore
export function usePriceListsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PriceListsQuery,
    PriceListsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<PriceListsQuery, PriceListsQueryVariables>
export function usePriceListsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PriceListsQuery, PriceListsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  PriceListsQuery | undefined,
  PriceListsQueryVariables
>
export function usePriceListsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PriceListsQuery, PriceListsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PriceListsQuery, PriceListsQueryVariables>(
    PriceListsDocument,
    options
  )
}
export type PriceListsQueryHookResult = ReturnType<typeof usePriceListsQuery>
export type PriceListsLazyQueryHookResult = ReturnType<
  typeof usePriceListsLazyQuery
>
export type PriceListsSuspenseQueryHookResult = ReturnType<
  typeof usePriceListsSuspenseQuery
>
export type PriceListsQueryResult = Apollo.QueryResult<
  PriceListsQuery,
  PriceListsQueryVariables
>
